module.exports = __webpack_public_path__ + "static/media/0c037b25.0c037b25.png";